<mat-card class="crud-search-card">
  <mat-card-title i18n="@@type.FirearmAssignment">Firearm Assignment</mat-card-title>
  <mat-card-content>
    <form [formGroup]="searchForm">
      <div class="search-section">

        <mat-form-field matTooltip="Firearm Assignment Id" [matTooltipDisabled]="disabledTooltip(this.firearmAssignmentId)">
          <mat-label i18n="@@type.FirearmAssignment.firearmAssignmentId">Firearm Assignment Id</mat-label>
          <input matInput formControlName="firearmAssignmentId" id="firearmAssignmentIdFilterInput"              
              (ngModelChange)="firearmAssignmentIdChanging($event)" [(ngModel)]="firearmAssignmentIdFilter"              
              (ngModelChange)="firearmAssignmentIdChanged($event)" #firearmAssignmentIdFilterInput              
              type="number" placeholder="Firearm Assignment Id">
        </mat-form-field>

        <mat-form-field matTooltip="Select a Firearm Assignment Type from the list" [matTooltipDisabled]="disabledTooltip(this.firearmAssignmentType)">
          <mat-label i18n="@@type.FirearmAssignment.firearmAssignmentType">Firearm Assignment Type</mat-label>
          <mat-select formControlName="firearmAssignmentType" id="firearmAssignmentTypeFilterInput"              
              (ngModelChange)="firearmAssignmentTypeChanging($event)" [(ngModel)]="firearmAssignmentTypeFilter"              
              (ngModelChange)="firearmAssignmentTypeChanged($event)" #firearmAssignmentTypeFilterInput              
              placeholder="Firearm Assignment Type">
            <mat-option>Any</mat-option>
            <mat-option *ngFor="let firearmAssignmentType of firearmAssignmentTypeSelectionList" [value]="firearmAssignmentType.code">
              {{firearmAssignmentType.meaning}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field matTooltip="Select a Personal Firearm Assignment from the list" [matTooltipDisabled]="disabledTooltip(this.personalFirearmAssignment)">
          <mat-label i18n="@@type.FirearmAssignment.personalFirearmAssignment">Personal Firearm Assignment</mat-label>
          <mat-select formControlName="personalFirearmAssignment" id="personalFirearmAssignmentFilterInput"              
              (ngModelChange)="personalFirearmAssignmentChanging($event)" [(ngModel)]="personalFirearmAssignmentFilter"              
              (ngModelChange)="personalFirearmAssignmentChanged($event)" #personalFirearmAssignmentFilterInput>
            <mat-option>Any</mat-option>
            <mat-option [value]="true" i18n="@@type.boolean.true">Yes</mat-option>
            <mat-option [value]="false" i18n="@@type.boolean.false">No</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field matTooltip="Select a Storage Type from the list" [matTooltipDisabled]="disabledTooltip(this.storageType)">
          <mat-label i18n="@@type.FirearmAssignment.storageType">Storage Type</mat-label>
          <mat-select formControlName="storageType" id="storageTypeFilterInput"              
              (ngModelChange)="storageTypeChanging($event)" [(ngModel)]="storageTypeFilter"              
              (ngModelChange)="storageTypeChanged($event)" #storageTypeFilterInput              
              placeholder="Storage Type">
            <mat-option>Any</mat-option>
            <mat-option *ngFor="let storageType of storageTypeSelectionList" [value]="storageType.code">
              {{storageType.meaning}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field matTooltip="Select a Lifecycle State from the list" [matTooltipDisabled]="disabledTooltip(this.lifecycleState)">
          <mat-label i18n="@@type.FirearmAssignment.lifecycleState">Lifecycle State</mat-label>
          <mat-select formControlName="lifecycleState" id="lifecycleStateFilterInput"              
              (ngModelChange)="lifecycleStateChanging($event)" [(ngModel)]="lifecycleStateFilter"              
              (ngModelChange)="lifecycleStateChanged($event)" #lifecycleStateFilterInput              
              placeholder="Lifecycle State">
            <mat-option>Any</mat-option>
            <mat-option *ngFor="let lifecycleState of lifecycleStateSelectionList" [value]="lifecycleState.code">
              {{lifecycleState.meaning}}
            </mat-option>
          </mat-select>
        </mat-form-field>
		
      </div>
      
      <div class="search-section">

        <mat-form-field matTooltip="Email" [matTooltipDisabled]="disabledTooltip(this.personEmail)">
          <mat-label i18n="@@type.FirearmAssignment.personEmail">Email</mat-label>
          <input matInput formControlName="personEmail" id="personEmailFilterInput"              
              (ngModelChange)="personEmailChanging($event)" [(ngModel)]="personEmailFilter"              
              (ngModelChange)="personEmailChanged($event)" #personEmailFilterInput              
              maxlength="255" placeholder="Email">
        </mat-form-field>

        <mat-form-field matTooltip="Select a User from the list" [matTooltipDisabled]="disabledTooltip(this.user)">
          <mat-label i18n="@@type.FirearmAssignment.user">User</mat-label>
          <mat-select formControlName="user" id="userFilterInput"              
              (ngModelChange)="userChanging($event)" [(ngModel)]="userFilter"              
              (ngModelChange)="userChanged($event)" #userFilterInput              
              placeholder="User" [compareWith]="userCompare">
            <mat-option>Any</mat-option>
            <mat-option *ngFor="let user of userSelectionList" [value]="user">
              {{userDisplay(user)}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field matTooltip="Select a Location from the list" [matTooltipDisabled]="disabledTooltip(this.location)">
          <mat-label i18n="@@type.FirearmAssignment.location">Location</mat-label>
          <mat-select formControlName="location" id="locationFilterInput"              
              (ngModelChange)="locationChanging($event)" [(ngModel)]="locationFilter"              
              (ngModelChange)="locationChanged($event)" #locationFilterInput              
              placeholder="Location" [compareWith]="locationCompare">
            <mat-option>Any</mat-option>
            <mat-option *ngFor="let location of locationSelectionList" [value]="location">
              {{locationDisplay(location)}}
            </mat-option>
          </mat-select>
        </mat-form-field>
		
      </div>
      
      <div class="search-section">

        <mat-form-field matTooltip="Comments" [matTooltipDisabled]="disabledTooltip(this.comments)">
          <mat-label i18n="@@type.FirearmAssignment.comments">Comments</mat-label>
          <input matInput formControlName="comments" id="commentsFilterInput"              
              (ngModelChange)="commentsChanging($event)" [(ngModel)]="commentsFilter"              
              (ngModelChange)="commentsChanged($event)" #commentsFilterInput              
              maxlength="1000" placeholder="Comments">
        </mat-form-field>

        <mat-form-field matTooltip="Select a Action Pending from the list" [matTooltipDisabled]="disabledTooltip(this.actionPending)">
          <mat-label i18n="@@type.FirearmAssignment.actionPending">Action Pending</mat-label>
          <mat-select formControlName="actionPending" id="actionPendingFilterInput"              
              (ngModelChange)="actionPendingChanging($event)" [(ngModel)]="actionPendingFilter"              
              (ngModelChange)="actionPendingChanged($event)" #actionPendingFilterInput              
              >
            <mat-option>Any</mat-option>
            <mat-option [value]="true" i18n="@@type.boolean.true">Yes</mat-option>
            <mat-option [value]="false" i18n="@@type.boolean.false">No</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field matTooltip="Select a Next Action from the list" [matTooltipDisabled]="disabledTooltip(this.nextAction)">
          <mat-label i18n="@@type.FirearmAssignment.nextAction">Next Action</mat-label>
          <mat-select formControlName="nextAction" id="nextActionFilterInput"              
              (ngModelChange)="nextActionChanging($event)" [(ngModel)]="nextActionFilter"              
              (ngModelChange)="nextActionChanged($event)" #nextActionFilterInput              
              placeholder="Next Action" [disabled]="true">
            <mat-option>Any</mat-option>
            <mat-option *ngFor="let nextAction of nextActionSelectionList" [value]="nextAction.code">
              {{nextAction.meaning}}
            </mat-option>
          </mat-select>
        </mat-form-field>
		
      </div>
      
      <div class="search-section">

        <mat-form-field matTooltip="Select a Bu Approved from the list" [matTooltipDisabled]="disabledTooltip(this.buApproved)">
          <mat-label i18n="@@type.FirearmAssignment.buApproved">Bu Approved</mat-label>
          <mat-select formControlName="buApproved" id="buApprovedFilterInput"              
              (ngModelChange)="buApprovedChanging($event)" [(ngModel)]="buApprovedFilter"              
              (ngModelChange)="buApprovedChanged($event)" #buApprovedFilterInput>
            <mat-option>Any</mat-option>
            <mat-option [value]="true" i18n="@@type.boolean.true">Yes</mat-option>
            <mat-option [value]="false" i18n="@@type.boolean.false">No</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field matTooltip="Bu Approved Rejected By" [matTooltipDisabled]="disabledTooltip(this.buApprovedRejectedBy)">
          <mat-label i18n="@@type.FirearmAssignment.buApprovedRejectedBy">Bu Approved Rejected By</mat-label>
          <input matInput formControlName="buApprovedRejectedBy" id="buApprovedRejectedByFilterInput"              
              (ngModelChange)="buApprovedRejectedByChanging($event)" [(ngModel)]="buApprovedRejectedByFilter"              
              (ngModelChange)="buApprovedRejectedByChanged($event)" #buApprovedRejectedByFilterInput              
              maxlength="255" placeholder="Bu Approved Rejected By">
        </mat-form-field>

        <mat-form-field matTooltip="Bu Approved Rejected Date From" [matTooltipDisabled]="disabledTooltip(this.buApprovedRejectedDateGreaterThanOrEqualTo)">
          <mat-label i18n="@@type.FirearmAssignment.buApprovedRejectedDateGreaterThanOrEqualTo">Bu Approved Rejected Date From</mat-label>
          <input matInput formControlName="buApprovedRejectedDateGreaterThanOrEqualTo" id="buApprovedRejectedDateGreaterThanOrEqualToFilterInput"              
              (ngModelChange)="buApprovedRejectedDateGreaterThanOrEqualToChanging($event)" [(ngModel)]="buApprovedRejectedDateGreaterThanOrEqualToFilter"              
              (ngModelChange)="buApprovedRejectedDateGreaterThanOrEqualToChanged($event)" #buApprovedRejectedDateGreaterThanOrEqualToFilterInput              
              [matDatepicker]="buApprovedRejectedDateGreaterThanOrEqualToDatePicker" (dateChange)="maybeDoAutoSearch()"              
              placeholder="Bu Approved Rejected Date From">
          <mat-datepicker-toggle matSuffix [for]="buApprovedRejectedDateGreaterThanOrEqualToDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #buApprovedRejectedDateGreaterThanOrEqualToDatePicker color="primary"></mat-datepicker>
        </mat-form-field>  
        <mat-form-field matTooltip="Bu Approved Rejected Date To" [matTooltipDisabled]="disabledTooltip(this.buApprovedRejectedDateLessThanOrEqualTo)">
          <mat-label i18n="@@type.FirearmAssignment.buApprovedRejectedDateLessThanOrEqualTo">Bu Approved Rejected Date To</mat-label>
          <input matInput formControlName="buApprovedRejectedDateLessThanOrEqualTo" id="buApprovedRejectedDateLessThanOrEqualToFilterInput"              
              (ngModelChange)="buApprovedRejectedDateLessThanOrEqualToChanging($event)" [(ngModel)]="buApprovedRejectedDateLessThanOrEqualToFilter"              
              (ngModelChange)="buApprovedRejectedDateLessThanOrEqualToChanged($event)" #buApprovedRejectedDateLessThanOrEqualToFilterInput              
              [matDatepicker]="buApprovedRejectedDateLessThanOrEqualToDatePicker" (dateChange)="maybeDoAutoSearch()"              
              placeholder="Bu Approved Rejected Date To">
          <mat-datepicker-toggle matSuffix [for]="buApprovedRejectedDateLessThanOrEqualToDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #buApprovedRejectedDateLessThanOrEqualToDatePicker color="primary"></mat-datepicker>
        </mat-form-field>

        <mat-form-field matTooltip="Bu Approval Rejection Reason" [matTooltipDisabled]="disabledTooltip(this.buApprovalRejectionReason)">
          <mat-label i18n="@@type.FirearmAssignment.buApprovalRejectionReason">Bu Approval Rejection Reason</mat-label>
          <input matInput formControlName="buApprovalRejectionReason" id="buApprovalRejectionReasonFilterInput"              
              (ngModelChange)="buApprovalRejectionReasonChanging($event)" [(ngModel)]="buApprovalRejectionReasonFilter"              
              (ngModelChange)="buApprovalRejectionReasonChanged($event)" #buApprovalRejectionReasonFilterInput              
              maxlength="1000" placeholder="Bu Approval Rejection Reason">
        </mat-form-field>
		
      </div>
      
      <div class="search-section">

        <mat-form-field matTooltip="Select a Lead Approved from the list" [matTooltipDisabled]="disabledTooltip(this.leadApproved)">
          <mat-label i18n="@@type.FirearmAssignment.leadApproved">Lead Approved</mat-label>
          <mat-select formControlName="leadApproved" id="leadApprovedFilterInput"              
              (ngModelChange)="leadApprovedChanging($event)" [(ngModel)]="leadApprovedFilter"              
              (ngModelChange)="leadApprovedChanged($event)" #leadApprovedFilterInput>
            <mat-option>Any</mat-option>
            <mat-option [value]="true" i18n="@@type.boolean.true">Yes</mat-option>
            <mat-option [value]="false" i18n="@@type.boolean.false">No</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field matTooltip="Lead Approved Rejected By" [matTooltipDisabled]="disabledTooltip(this.leadApprovedRejectedBy)">
          <mat-label i18n="@@type.FirearmAssignment.leadApprovedRejectedBy">Lead Approved Rejected By</mat-label>
          <input matInput formControlName="leadApprovedRejectedBy" id="leadApprovedRejectedByFilterInput"              
              (ngModelChange)="leadApprovedRejectedByChanging($event)" [(ngModel)]="leadApprovedRejectedByFilter"              
              (ngModelChange)="leadApprovedRejectedByChanged($event)" #leadApprovedRejectedByFilterInput              
              maxlength="255" placeholder="Lead Approved Rejected By">
        </mat-form-field>

        <mat-form-field matTooltip="Lead Approved Rejected Date From" [matTooltipDisabled]="disabledTooltip(this.leadApprovedRejectedDateGreaterThanOrEqualTo)">
          <mat-label i18n="@@type.FirearmAssignment.leadApprovedRejectedDateGreaterThanOrEqualTo">Lead Approved Rejected Date From</mat-label>
          <input matInput formControlName="leadApprovedRejectedDateGreaterThanOrEqualTo" id="leadApprovedRejectedDateGreaterThanOrEqualToFilterInput"              
              (ngModelChange)="leadApprovedRejectedDateGreaterThanOrEqualToChanging($event)" [(ngModel)]="leadApprovedRejectedDateGreaterThanOrEqualToFilter"              
              (ngModelChange)="leadApprovedRejectedDateGreaterThanOrEqualToChanged($event)" #leadApprovedRejectedDateGreaterThanOrEqualToFilterInput              
              [matDatepicker]="leadApprovedRejectedDateGreaterThanOrEqualToDatePicker" (dateChange)="maybeDoAutoSearch()"              
              placeholder="Lead Approved Rejected Date From">
          <mat-datepicker-toggle matSuffix [for]="leadApprovedRejectedDateGreaterThanOrEqualToDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #leadApprovedRejectedDateGreaterThanOrEqualToDatePicker color="primary"></mat-datepicker>
        </mat-form-field>  
        <mat-form-field matTooltip="Lead Approved Rejected Date To" [matTooltipDisabled]="disabledTooltip(this.leadApprovedRejectedDateLessThanOrEqualTo)">
          <mat-label i18n="@@type.FirearmAssignment.leadApprovedRejectedDateLessThanOrEqualTo">Lead Approved Rejected Date To</mat-label>
          <input matInput formControlName="leadApprovedRejectedDateLessThanOrEqualTo" id="leadApprovedRejectedDateLessThanOrEqualToFilterInput"              
              (ngModelChange)="leadApprovedRejectedDateLessThanOrEqualToChanging($event)" [(ngModel)]="leadApprovedRejectedDateLessThanOrEqualToFilter"              
              (ngModelChange)="leadApprovedRejectedDateLessThanOrEqualToChanged($event)" #leadApprovedRejectedDateLessThanOrEqualToFilterInput              
              [matDatepicker]="leadApprovedRejectedDateLessThanOrEqualToDatePicker" (dateChange)="maybeDoAutoSearch()"              
              placeholder="Lead Approved Rejected Date To">
          <mat-datepicker-toggle matSuffix [for]="leadApprovedRejectedDateLessThanOrEqualToDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #leadApprovedRejectedDateLessThanOrEqualToDatePicker color="primary"></mat-datepicker>
        </mat-form-field>

        <mat-form-field matTooltip="Lead Approval Rejection Reason" [matTooltipDisabled]="disabledTooltip(this.leadApprovalRejectionReason)">
          <mat-label i18n="@@type.FirearmAssignment.leadApprovalRejectionReason">Lead Approval Rejection Reason</mat-label>
          <input matInput formControlName="leadApprovalRejectionReason" id="leadApprovalRejectionReasonFilterInput"              
              (ngModelChange)="leadApprovalRejectionReasonChanging($event)" [(ngModel)]="leadApprovalRejectionReasonFilter"              
              (ngModelChange)="leadApprovalRejectionReasonChanged($event)" #leadApprovalRejectionReasonFilterInput              
              maxlength="1000" placeholder="Lead Approval Rejection Reason">
        </mat-form-field>
		
      </div>
      
      <div class="search-section">

        <mat-form-field matTooltip="Activated By" [matTooltipDisabled]="disabledTooltip(this.activatedBy)">
          <mat-label i18n="@@type.FirearmAssignment.activatedBy">Activated By</mat-label>
          <input matInput formControlName="activatedBy" id="activatedByFilterInput"              
              (ngModelChange)="activatedByChanging($event)" [(ngModel)]="activatedByFilter"              
              (ngModelChange)="activatedByChanged($event)" #activatedByFilterInput              
              maxlength="255" placeholder="Activated By">
        </mat-form-field>

        <mat-form-field matTooltip="Activated Date From" [matTooltipDisabled]="disabledTooltip(this.activatedDateGreaterThanOrEqualTo)">
          <mat-label i18n="@@type.FirearmAssignment.activatedDateGreaterThanOrEqualTo">Activated Date From</mat-label>
          <input matInput formControlName="activatedDateGreaterThanOrEqualTo" id="activatedDateGreaterThanOrEqualToFilterInput"              
              (ngModelChange)="activatedDateGreaterThanOrEqualToChanging($event)" [(ngModel)]="activatedDateGreaterThanOrEqualToFilter"              
              (ngModelChange)="activatedDateGreaterThanOrEqualToChanged($event)" #activatedDateGreaterThanOrEqualToFilterInput              
              [matDatepicker]="activatedDateGreaterThanOrEqualToDatePicker" (dateChange)="maybeDoAutoSearch()"              
              placeholder="Activated Date From">
          <mat-datepicker-toggle matSuffix [for]="activatedDateGreaterThanOrEqualToDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #activatedDateGreaterThanOrEqualToDatePicker color="primary"></mat-datepicker>
        </mat-form-field>  
        <mat-form-field matTooltip="Activated Date To" [matTooltipDisabled]="disabledTooltip(this.activatedDateLessThanOrEqualTo)">
          <mat-label i18n="@@type.FirearmAssignment.activatedDateLessThanOrEqualTo">Activated Date To</mat-label>
          <input matInput formControlName="activatedDateLessThanOrEqualTo" id="activatedDateLessThanOrEqualToFilterInput"              
              (ngModelChange)="activatedDateLessThanOrEqualToChanging($event)" [(ngModel)]="activatedDateLessThanOrEqualToFilter"              
              (ngModelChange)="activatedDateLessThanOrEqualToChanged($event)" #activatedDateLessThanOrEqualToFilterInput              
              [matDatepicker]="activatedDateLessThanOrEqualToDatePicker" (dateChange)="maybeDoAutoSearch()"              
              placeholder="Activated Date To">
          <mat-datepicker-toggle matSuffix [for]="activatedDateLessThanOrEqualToDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #activatedDateLessThanOrEqualToDatePicker color="primary"></mat-datepicker>
        </mat-form-field>
		
      </div>
      
      <div class="search-section">

        <mat-form-field matTooltip="Canceled By" [matTooltipDisabled]="disabledTooltip(this.canceledBy)">
          <mat-label i18n="@@type.FirearmAssignment.canceledBy">Canceled By</mat-label>
          <input matInput formControlName="canceledBy" id="canceledByFilterInput"              
              (ngModelChange)="canceledByChanging($event)" [(ngModel)]="canceledByFilter"              
              (ngModelChange)="canceledByChanged($event)" #canceledByFilterInput              
              maxlength="255" placeholder="Canceled By">
        </mat-form-field>

        <mat-form-field matTooltip="Canceled Date From" [matTooltipDisabled]="disabledTooltip(this.canceledDateGreaterThanOrEqualTo)">
          <mat-label i18n="@@type.FirearmAssignment.canceledDateGreaterThanOrEqualTo">Canceled Date From</mat-label>
          <input matInput formControlName="canceledDateGreaterThanOrEqualTo" id="canceledDateGreaterThanOrEqualToFilterInput"              
              (ngModelChange)="canceledDateGreaterThanOrEqualToChanging($event)" [(ngModel)]="canceledDateGreaterThanOrEqualToFilter"              
              (ngModelChange)="canceledDateGreaterThanOrEqualToChanged($event)" #canceledDateGreaterThanOrEqualToFilterInput              
              [matDatepicker]="canceledDateGreaterThanOrEqualToDatePicker" (dateChange)="maybeDoAutoSearch()"              
              placeholder="Canceled Date From">
          <mat-datepicker-toggle matSuffix [for]="canceledDateGreaterThanOrEqualToDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #canceledDateGreaterThanOrEqualToDatePicker color="primary"></mat-datepicker>
        </mat-form-field>  
        <mat-form-field matTooltip="Canceled Date To" [matTooltipDisabled]="disabledTooltip(this.canceledDateLessThanOrEqualTo)">
          <mat-label i18n="@@type.FirearmAssignment.canceledDateLessThanOrEqualTo">Canceled Date To</mat-label>
          <input matInput formControlName="canceledDateLessThanOrEqualTo" id="canceledDateLessThanOrEqualToFilterInput"              
              (ngModelChange)="canceledDateLessThanOrEqualToChanging($event)" [(ngModel)]="canceledDateLessThanOrEqualToFilter"              
              (ngModelChange)="canceledDateLessThanOrEqualToChanged($event)" #canceledDateLessThanOrEqualToFilterInput              
              [matDatepicker]="canceledDateLessThanOrEqualToDatePicker" (dateChange)="maybeDoAutoSearch()"              
              placeholder="Canceled Date To">
          <mat-datepicker-toggle matSuffix [for]="canceledDateLessThanOrEqualToDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #canceledDateLessThanOrEqualToDatePicker color="primary"></mat-datepicker>
        </mat-form-field>

        <mat-form-field matTooltip="Canceled Reason" [matTooltipDisabled]="disabledTooltip(this.canceledReason)">
          <mat-label i18n="@@type.FirearmAssignment.canceledReason">Canceled Reason</mat-label>
          <input matInput formControlName="canceledReason" id="canceledReasonFilterInput"              
              (ngModelChange)="canceledReasonChanging($event)" [(ngModel)]="canceledReasonFilter"              
              (ngModelChange)="canceledReasonChanged($event)" #canceledReasonFilterInput              
              maxlength="1000" placeholder="Canceled Reason">
        </mat-form-field>
		
      </div>
      
      <div class="search-section">

        <mat-form-field matTooltip="Started By" [matTooltipDisabled]="disabledTooltip(this.startedBy)">
          <mat-label i18n="@@type.FirearmAssignment.startedBy">Started By</mat-label>
          <input matInput formControlName="startedBy" id="startedByFilterInput"              
              (ngModelChange)="startedByChanging($event)" [(ngModel)]="startedByFilter"              
              (ngModelChange)="startedByChanged($event)" #startedByFilterInput              
              maxlength="255" placeholder="Started By">
        </mat-form-field>

        <mat-form-field matTooltip="Start Date From" [matTooltipDisabled]="disabledTooltip(this.startDateGreaterThanOrEqualTo)">
          <mat-label i18n="@@type.FirearmAssignment.startDateGreaterThanOrEqualTo">Start Date From</mat-label>
          <input matInput formControlName="startDateGreaterThanOrEqualTo" id="startDateGreaterThanOrEqualToFilterInput"              
              (ngModelChange)="startDateGreaterThanOrEqualToChanging($event)" [(ngModel)]="startDateGreaterThanOrEqualToFilter"              
              (ngModelChange)="startDateGreaterThanOrEqualToChanged($event)" #startDateGreaterThanOrEqualToFilterInput              
              [matDatepicker]="startDateGreaterThanOrEqualToDatePicker" (dateChange)="maybeDoAutoSearch()"              
              placeholder="Start Date From">
          <mat-datepicker-toggle matSuffix [for]="startDateGreaterThanOrEqualToDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #startDateGreaterThanOrEqualToDatePicker color="primary"></mat-datepicker>
        </mat-form-field>  
        <mat-form-field matTooltip="Start Date To" [matTooltipDisabled]="disabledTooltip(this.startDateLessThanOrEqualTo)">
          <mat-label i18n="@@type.FirearmAssignment.startDateLessThanOrEqualTo">Start Date To</mat-label>
          <input matInput formControlName="startDateLessThanOrEqualTo" id="startDateLessThanOrEqualToFilterInput"              
              (ngModelChange)="startDateLessThanOrEqualToChanging($event)" [(ngModel)]="startDateLessThanOrEqualToFilter"              
              (ngModelChange)="startDateLessThanOrEqualToChanged($event)" #startDateLessThanOrEqualToFilterInput              
              [matDatepicker]="startDateLessThanOrEqualToDatePicker" (dateChange)="maybeDoAutoSearch()"              
              placeholder="Start Date To">
          <mat-datepicker-toggle matSuffix [for]="startDateLessThanOrEqualToDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #startDateLessThanOrEqualToDatePicker color="primary"></mat-datepicker>
        </mat-form-field>
		

        <mat-form-field matTooltip="End Date From" [matTooltipDisabled]="disabledTooltip(this.endDateGreaterThanOrEqualTo)">
          <mat-label i18n="@@type.FirearmAssignment.endDateGreaterThanOrEqualTo">End Date From</mat-label>
          <input matInput formControlName="endDateGreaterThanOrEqualTo" id="endDateGreaterThanOrEqualToFilterInput"              
              (ngModelChange)="endDateGreaterThanOrEqualToChanging($event)" [(ngModel)]="endDateGreaterThanOrEqualToFilter"              
              (ngModelChange)="endDateGreaterThanOrEqualToChanged($event)" #endDateGreaterThanOrEqualToFilterInput              
              [matDatepicker]="endDateGreaterThanOrEqualToDatePicker" (dateChange)="maybeDoAutoSearch()"              
              placeholder="End Date From" >
          <mat-datepicker-toggle matSuffix [for]="endDateGreaterThanOrEqualToDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #endDateGreaterThanOrEqualToDatePicker color="primary"></mat-datepicker>
        </mat-form-field>  
        <mat-form-field matTooltip="End Date To" [matTooltipDisabled]="disabledTooltip(this.endDateLessThanOrEqualTo)">
          <mat-label i18n="@@type.FirearmAssignment.endDateLessThanOrEqualTo">End Date To</mat-label>
          <input matInput formControlName="endDateLessThanOrEqualTo" id="endDateLessThanOrEqualToFilterInput"              
              (ngModelChange)="endDateLessThanOrEqualToChanging($event)" [(ngModel)]="endDateLessThanOrEqualToFilter"              
              (ngModelChange)="endDateLessThanOrEqualToChanged($event)" #endDateLessThanOrEqualToFilterInput              
              [matDatepicker]="endDateLessThanOrEqualToDatePicker" (dateChange)="maybeDoAutoSearch()"              
              placeholder="End Date To" >
          <mat-datepicker-toggle matSuffix [for]="endDateLessThanOrEqualToDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #endDateLessThanOrEqualToDatePicker color="primary"></mat-datepicker>
        </mat-form-field>
      </div>
      
      <div class="search-section">

        <mat-form-field matTooltip="Last State Change Date From" [matTooltipDisabled]="disabledTooltip(this.lastStateChangeDateGreaterThanOrEqualTo)">
          <mat-label i18n="@@type.FirearmAssignment.lastStateChangeDateGreaterThanOrEqualTo">Last State Change Date From</mat-label>
          <input matInput formControlName="lastStateChangeDateGreaterThanOrEqualTo" id="lastStateChangeDateGreaterThanOrEqualToFilterInput"              
              (ngModelChange)="lastStateChangeDateGreaterThanOrEqualToChanging($event)" [(ngModel)]="lastStateChangeDateGreaterThanOrEqualToFilter"              
              (ngModelChange)="lastStateChangeDateGreaterThanOrEqualToChanged($event)" #lastStateChangeDateGreaterThanOrEqualToFilterInput              
              [matDatepicker]="lastStateChangeDateGreaterThanOrEqualToDatePicker" (dateChange)="maybeDoAutoSearch()"              
              placeholder="Last State Change Date From" >
          <mat-datepicker-toggle matSuffix [for]="lastStateChangeDateGreaterThanOrEqualToDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #lastStateChangeDateGreaterThanOrEqualToDatePicker color="primary"></mat-datepicker>
        </mat-form-field>  
        <mat-form-field matTooltip="Last State Change Date To" [matTooltipDisabled]="disabledTooltip(this.lastStateChangeDateLessThanOrEqualTo)">
          <mat-label i18n="@@type.FirearmAssignment.lastStateChangeDateLessThanOrEqualTo">Last State Change Date To</mat-label>
          <input matInput formControlName="lastStateChangeDateLessThanOrEqualTo" id="lastStateChangeDateLessThanOrEqualToFilterInput"              
              (ngModelChange)="lastStateChangeDateLessThanOrEqualToChanging($event)" [(ngModel)]="lastStateChangeDateLessThanOrEqualToFilter"              
              (ngModelChange)="lastStateChangeDateLessThanOrEqualToChanged($event)" #lastStateChangeDateLessThanOrEqualToFilterInput              
              [matDatepicker]="lastStateChangeDateLessThanOrEqualToDatePicker" (dateChange)="maybeDoAutoSearch()"              
              placeholder="Last State Change Date To" >
          <mat-datepicker-toggle matSuffix [for]="lastStateChangeDateLessThanOrEqualToDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #lastStateChangeDateLessThanOrEqualToDatePicker color="primary"></mat-datepicker>
        </mat-form-field>
		
      </div>
      
      <div class="search-section">

        <mat-form-field matTooltip="Select a Notify Police from the list" [matTooltipDisabled]="disabledTooltip(this.notifyPolice)">
          <mat-label i18n="@@type.FirearmAssignment.notifyPolice">Notify Police</mat-label>
          <mat-select formControlName="notifyPolice" id="notifyPoliceFilterInput"              
              (ngModelChange)="notifyPoliceChanging($event)" [(ngModel)]="notifyPoliceFilter"              
              (ngModelChange)="notifyPoliceChanged($event)" #notifyPoliceFilterInput>
            <mat-option>Any</mat-option>
            <mat-option [value]="true" i18n="@@type.boolean.true">Yes</mat-option>
            <mat-option [value]="false" i18n="@@type.boolean.false">No</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field matTooltip="Police Notification Reason" [matTooltipDisabled]="disabledTooltip(this.policeNotificationReason)">
          <mat-label i18n="@@type.FirearmAssignment.policeNotificationReason">Police Notification Reason / Comments</mat-label>
          <input matInput formControlName="policeNotificationReason" id="policeNotificationReasonFilterInput"              
              (ngModelChange)="policeNotificationReasonChanging($event)" [(ngModel)]="policeNotificationReasonFilter"              
              (ngModelChange)="policeNotificationReasonChanged($event)" #policeNotificationReasonFilterInput              
              maxlength="2000" placeholder="Police Notification Reason / Comments">
        </mat-form-field>

        <mat-form-field matTooltip="Police Notified Date From" [matTooltipDisabled]="disabledTooltip(this.policeNotifiedDateGreaterThanOrEqualTo)">
          <mat-label i18n="@@type.FirearmAssignment.policeNotifiedDateGreaterThanOrEqualTo">Police Notified Date From</mat-label>
          <input matInput formControlName="policeNotifiedDateGreaterThanOrEqualTo" id="policeNotifiedDateGreaterThanOrEqualToFilterInput"              
              (ngModelChange)="policeNotifiedDateGreaterThanOrEqualToChanging($event)" [(ngModel)]="policeNotifiedDateGreaterThanOrEqualToFilter"              
              (ngModelChange)="policeNotifiedDateGreaterThanOrEqualToChanged($event)" #policeNotifiedDateGreaterThanOrEqualToFilterInput              
              [matDatepicker]="policeNotifiedDateGreaterThanOrEqualToDatePicker" (dateChange)="maybeDoAutoSearch()"              
              placeholder="Police Notified Date From">
          <mat-datepicker-toggle matSuffix [for]="policeNotifiedDateGreaterThanOrEqualToDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #policeNotifiedDateGreaterThanOrEqualToDatePicker color="primary"></mat-datepicker>
        </mat-form-field>  
        <mat-form-field matTooltip="Police Notified Date To" [matTooltipDisabled]="disabledTooltip(this.policeNotifiedDateLessThanOrEqualTo)">
          <mat-label i18n="@@type.FirearmAssignment.policeNotifiedDateLessThanOrEqualTo">Police Notified Date To</mat-label>
          <input matInput formControlName="policeNotifiedDateLessThanOrEqualTo" id="policeNotifiedDateLessThanOrEqualToFilterInput"              
              (ngModelChange)="policeNotifiedDateLessThanOrEqualToChanging($event)" [(ngModel)]="policeNotifiedDateLessThanOrEqualToFilter"              
              (ngModelChange)="policeNotifiedDateLessThanOrEqualToChanged($event)" #policeNotifiedDateLessThanOrEqualToFilterInput              
              [matDatepicker]="policeNotifiedDateLessThanOrEqualToDatePicker" (dateChange)="maybeDoAutoSearch()"              
              placeholder="Police Notified Date To">
          <mat-datepicker-toggle matSuffix [for]="policeNotifiedDateLessThanOrEqualToDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #policeNotifiedDateLessThanOrEqualToDatePicker color="primary"></mat-datepicker>
        </mat-form-field>
		
      </div>
      
      <div class="search-section">

        <mat-form-field matTooltip="Created By" [matTooltipDisabled]="disabledTooltip(this.createdBy)">
          <mat-label i18n="@@type.FirearmAssignment.createdBy">Created By</mat-label>
          <input matInput formControlName="createdBy" id="createdByFilterInput"              
              (ngModelChange)="createdByChanging($event)" [(ngModel)]="createdByFilter"              
              (ngModelChange)="createdByChanged($event)" #createdByFilterInput              
              maxlength="255" placeholder="Created By">
        </mat-form-field>

        <mat-form-field matTooltip="Created Date From" [matTooltipDisabled]="disabledTooltip(this.createdDateGreaterThanOrEqualTo)">
          <mat-label i18n="@@type.FirearmAssignment.createdDateGreaterThanOrEqualTo">Created Date From</mat-label>
          <input matInput formControlName="createdDateGreaterThanOrEqualTo" id="createdDateGreaterThanOrEqualToFilterInput"              
              (ngModelChange)="createdDateGreaterThanOrEqualToChanging($event)" [(ngModel)]="createdDateGreaterThanOrEqualToFilter"              
              (ngModelChange)="createdDateGreaterThanOrEqualToChanged($event)" #createdDateGreaterThanOrEqualToFilterInput              
              [matDatepicker]="createdDateGreaterThanOrEqualToDatePicker" (dateChange)="maybeDoAutoSearch()"              
              placeholder="Created Date From">
          <mat-datepicker-toggle matSuffix [for]="createdDateGreaterThanOrEqualToDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #createdDateGreaterThanOrEqualToDatePicker color="primary"></mat-datepicker>
        </mat-form-field>  
        <mat-form-field matTooltip="Created Date To" [matTooltipDisabled]="disabledTooltip(this.createdDateLessThanOrEqualTo)">
          <mat-label i18n="@@type.FirearmAssignment.createdDateLessThanOrEqualTo">Created Date To</mat-label>
          <input matInput formControlName="createdDateLessThanOrEqualTo" id="createdDateLessThanOrEqualToFilterInput"              
              (ngModelChange)="createdDateLessThanOrEqualToChanging($event)" [(ngModel)]="createdDateLessThanOrEqualToFilter"              
              (ngModelChange)="createdDateLessThanOrEqualToChanged($event)" #createdDateLessThanOrEqualToFilterInput              
              [matDatepicker]="createdDateLessThanOrEqualToDatePicker" (dateChange)="maybeDoAutoSearch()"              
              placeholder="Created Date To">
          <mat-datepicker-toggle matSuffix [for]="createdDateLessThanOrEqualToDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #createdDateLessThanOrEqualToDatePicker color="primary"></mat-datepicker>
        </mat-form-field>

        <mat-form-field matTooltip="Updated By" [matTooltipDisabled]="disabledTooltip(this.updatedBy)">
          <mat-label i18n="@@type.FirearmAssignment.updatedBy">Updated By</mat-label>
          <input matInput formControlName="updatedBy" id="updatedByFilterInput"              
              (ngModelChange)="updatedByChanging($event)" [(ngModel)]="updatedByFilter"              
              (ngModelChange)="updatedByChanged($event)" #updatedByFilterInput              
              maxlength="255" placeholder="Updated By">
        </mat-form-field>


        <mat-form-field matTooltip="Updated Date From" [matTooltipDisabled]="disabledTooltip(this.updatedDateGreaterThanOrEqualTo)">
          <mat-label i18n="@@type.FirearmAssignment.updatedDateGreaterThanOrEqualTo">Updated Date From</mat-label>
          <input matInput formControlName="updatedDateGreaterThanOrEqualTo" id="updatedDateGreaterThanOrEqualToFilterInput"              
              (ngModelChange)="updatedDateGreaterThanOrEqualToChanging($event)" [(ngModel)]="updatedDateGreaterThanOrEqualToFilter"              
              (ngModelChange)="updatedDateGreaterThanOrEqualToChanged($event)" #updatedDateGreaterThanOrEqualToFilterInput              
              [matDatepicker]="updatedDateGreaterThanOrEqualToDatePicker" (dateChange)="maybeDoAutoSearch()"              
              placeholder="Updated Date From">
          <mat-datepicker-toggle matSuffix [for]="updatedDateGreaterThanOrEqualToDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #updatedDateGreaterThanOrEqualToDatePicker color="primary"></mat-datepicker>
        </mat-form-field>  
        <mat-form-field matTooltip="Updated Date To" [matTooltipDisabled]="disabledTooltip(this.updatedDateLessThanOrEqualTo)">
          <mat-label i18n="@@type.FirearmAssignment.updatedDateLessThanOrEqualTo">Updated Date To</mat-label>
          <input matInput formControlName="updatedDateLessThanOrEqualTo" id="updatedDateLessThanOrEqualToFilterInput"              
              (ngModelChange)="updatedDateLessThanOrEqualToChanging($event)" [(ngModel)]="updatedDateLessThanOrEqualToFilter"              
              (ngModelChange)="updatedDateLessThanOrEqualToChanged($event)" #updatedDateLessThanOrEqualToFilterInput              
              [matDatepicker]="updatedDateLessThanOrEqualToDatePicker" (dateChange)="maybeDoAutoSearch()"              
              placeholder="Updated Date To">
          <mat-datepicker-toggle matSuffix [for]="updatedDateLessThanOrEqualToDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #updatedDateLessThanOrEqualToDatePicker color="primary"></mat-datepicker>
        </mat-form-field>
		
      </div>
      
      <div class="search-section">

		<mat-slide-toggle floatLabel="always" appearance="none" color="primary"  *ngIf="autoSearchControlsEnabled"
          [(ngModel)]="autoSearch"  [ngModelOptions]="{standalone: true}">
            Auto Search
        </mat-slide-toggle>

        <button mat-raised-button color="primary" class="action-button" (click)="forceSearch()" type="button"
          i18n="@@actions.search">Search</button>
		  

        <button mat-raised-button color="primary" class="action-button" (click)="clearFilters()" type="button"
          [disabled]="!allowsClearFilters()" i18n="@@actions.clearFilters">Clear Filters</button>
      </div>
			
    </form>

    <div class="mat-elevation-z8">
      <div class="mat-table-wrapper">
        <mat-table #table [dataSource]="dataSource" matSort
                           matSortDirection="asc" matSortDisableClear cdkDropList cdkDropListLockAxis="x"
                           cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" Group>

          <ng-container matColumnDef="firearmAssignmentId">
            <mat-header-cell [crud-column-header]="columns.column('firearmAssignmentId')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.FirearmAssignment.firearmAssignmentId">
                Firearm Assignment Id 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.firearmAssignmentId | number:'1.0-2':'en-GB'}}
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="firearm">
            <mat-header-cell [crud-column-header]="columns.column('assetId')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-smallx2" i18n="@@type.FirearmAssignment.assetId">
                Firearm
              </mat-header-cell>
            <mat-cell class="search-column-smallx2" *matCellDef="let element">
              {{firearmDisplay(element.firearm)}}
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="location.firearmStorageLocationId">
            <mat-header-cell [crud-column-header]="columns.column('location.firearmStorageLocationId')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-smallx2" i18n="@@type.FirearmAssignment.location">
                Location 
              </mat-header-cell>
            <mat-cell class="search-column-smallx2" *matCellDef="let element">
              {{element.location?.firearmStorageLocationId}} - {{element.location?.description}}
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="rangerId">
            <mat-header-cell [crud-column-header]="columns.column('rangerId')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-smallx2" i18n="@@type.FirearmAssignment.rangerId">
                Ranger
              </mat-header-cell>
            <mat-cell class="search-column-smallx2" *matCellDef="let element">
              {{element.ranger?.name}}
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="user.user">
            <mat-header-cell [crud-column-header]="columns.column('user.user')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.FirearmAssignment.user">
                User 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.user?.user}}
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="actionPending">
            <mat-header-cell [crud-column-header]="columns.column('actionPending')" *matHeaderCellDef 
              cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.FirearmAssignment.actionPending">
                Action Pending 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              <mat-icon *ngIf="element.actionPending">check_box</mat-icon><mat-icon *ngIf="!element.actionPending">check_box_outline_blank</mat-icon>
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="activatedBy">
            <mat-header-cell [crud-column-header]="columns.column('activatedBy')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.FirearmAssignment.activatedBy">
                Activated By 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.activatedBy}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="personalFirearmAssignment">
            <mat-header-cell [crud-column-header]="columns.column('personalFirearmAssignment')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.FirearmAssignment.personalFirearmAssignment">
                Personal Firearm Assignment 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              <mat-icon *ngIf="element.personalFirearmAssignment">check_box</mat-icon><mat-icon *ngIf="!element.personalFirearmAssignment">check_box_outline_blank</mat-icon>
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="activatedDate">
            <mat-header-cell [crud-column-header]="columns.column('activatedDate')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.FirearmAssignment.activatedDate">
                Activated Date 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.activatedDate | uimDateTimeFormat}}
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="buApprovalRejectionReason">
            <mat-header-cell [crud-column-header]="columns.column('buApprovalRejectionReason')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.FirearmAssignment.buApprovalRejectionReason">
                Bu Approval Rejection Reason 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.buApprovalRejectionReason}}
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="buApproved">
            <mat-header-cell [crud-column-header]="columns.column('buApproved')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.FirearmAssignment.buApproved">
                Bu Approved 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              <mat-icon *ngIf="element.buApproved">check_box</mat-icon><mat-icon *ngIf="!element.buApproved">check_box_outline_blank</mat-icon>
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="buApprovedRejectedBy">
            <mat-header-cell [crud-column-header]="columns.column('buApprovedRejectedBy')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.FirearmAssignment.buApprovedRejectedBy">
                Bu Approved Rejected By 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.buApprovedRejectedBy}}
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="buApprovedRejectedDate">
            <mat-header-cell [crud-column-header]="columns.column('buApprovedRejectedDate')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.FirearmAssignment.buApprovedRejectedDate">
                Bu Approved Rejected Date 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.buApprovedRejectedDate | uimDateTimeFormat}}
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="canceledBy">
            <mat-header-cell [crud-column-header]="columns.column('canceledBy')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.FirearmAssignment.canceledBy">
                Canceled By 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.canceledBy}}
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="canceledDate">
            <mat-header-cell [crud-column-header]="columns.column('canceledDate')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.FirearmAssignment.canceledDate">
                Canceled Date 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.canceledDate | uimDateTimeFormat}}
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="canceledReason">
            <mat-header-cell [crud-column-header]="columns.column('canceledReason')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.FirearmAssignment.canceledReason">
                Canceled Reason 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.canceledReason}}
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="comments">
            <mat-header-cell [crud-column-header]="columns.column('comments')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.FirearmAssignment.comments">
                Comments 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.comments}}
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="createdBy">
            <mat-header-cell [crud-column-header]="columns.column('createdBy')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.FirearmAssignment.createdBy">
                Created By 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.createdBy}}
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="createdDate">
            <mat-header-cell [crud-column-header]="columns.column('createdDate')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.FirearmAssignment.createdDate">
                Created Date 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.createdDate | uimDateTimeFormat}}
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="currentAssignment">
            <mat-header-cell [crud-column-header]="columns.column('currentAssignment')" *matHeaderCellDef 
              cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.FirearmAssignment.currentAssignment">
                Current Assignment 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              <mat-icon *ngIf="element.currentAssignment">check_box</mat-icon><mat-icon *ngIf="!element.currentAssignment">check_box_outline_blank</mat-icon>
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="endDate">
            <mat-header-cell [crud-column-header]="columns.column('endDate')" *matHeaderCellDef 
              cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.FirearmAssignment.endDate">
                End Date 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.endDate | uimDateTimeFormat}}
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="firearmAssignmentType">
            <mat-header-cell [crud-column-header]="columns.column('firearmAssignmentType')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.FirearmAssignment.firearmAssignmentType">
                Firearm Assignment Type 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.firearmAssignmentType | refDecode:'FIREARM_ASSIGNMENT_TYPE' | async}}
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="storageType">
            <mat-header-cell [crud-column-header]="columns.column('storageType')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.FirearmAssignment.storageType">
                Storage Type 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.storageType | refDecode:'FIREARM_ASSIGNMENT_STORAGE_TYPE' | async}}
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="lastStateChangeDate">
            <mat-header-cell [crud-column-header]="columns.column('lastStateChangeDate')" *matHeaderCellDef 
              cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.FirearmAssignment.lastStateChangeDate">
                Last State Change Date 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.lastStateChangeDate | uimDateTimeFormat}}
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="leadApprovalRejectionReason">
            <mat-header-cell [crud-column-header]="columns.column('leadApprovalRejectionReason')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.FirearmAssignment.leadApprovalRejectionReason">
                Lead Approval Rejection Reason 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.leadApprovalRejectionReason}}
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="leadApproved">
            <mat-header-cell [crud-column-header]="columns.column('leadApproved')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.FirearmAssignment.leadApproved">
                Lead Approved 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              <mat-icon *ngIf="element.leadApproved">check_box</mat-icon><mat-icon *ngIf="!element.leadApproved">check_box_outline_blank</mat-icon>
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="leadApprovedRejectedBy">
            <mat-header-cell [crud-column-header]="columns.column('leadApprovedRejectedBy')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.FirearmAssignment.leadApprovedRejectedBy">
                Lead Approved Rejected By 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.leadApprovedRejectedBy}}
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="leadApprovedRejectedDate">
            <mat-header-cell [crud-column-header]="columns.column('leadApprovedRejectedDate')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.FirearmAssignment.leadApprovedRejectedDate">
                Lead Approved Rejected Date 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.leadApprovedRejectedDate | uimDateTimeFormat}}
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="lifecycleState">
            <mat-header-cell [crud-column-header]="columns.column('lifecycleState')" *matHeaderCellDef 
              cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.FirearmAssignment.lifecycleState">
                Lifecycle State 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.lifecycleState | refDecode:'FIREARM_ASSIGNMENT_LIFECYCLE_STATE' | async}}
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="locationId">
            <mat-header-cell [crud-column-header]="columns.column('locationId')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.FirearmAssignment.locationId">
                Location Id 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.locationId | number:'1.0-2':'en-GB'}}
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="lockVersion">
            <mat-header-cell [crud-column-header]="columns.column('lockVersion')" *matHeaderCellDef 
              cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.FirearmAssignment.lockVersion">
                Lock Version 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.lockVersion | number:'1.0-2':'en-GB'}}
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="nextAction">
            <mat-header-cell [crud-column-header]="columns.column('nextAction')" *matHeaderCellDef 
              cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.FirearmAssignment.nextAction">
                Next Action 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.nextAction | refDecode:'FIREARM_ASSIGNMENT_NEXT_ACTION' | async}}
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="notifyPolice">
            <mat-header-cell [crud-column-header]="columns.column('notifyPolice')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.FirearmAssignment.notifyPolice">
                Notify Police 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              <mat-icon *ngIf="element.notifyPolice">check_box</mat-icon><mat-icon *ngIf="!element.notifyPolice">check_box_outline_blank</mat-icon>
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="personEmail">
            <mat-header-cell [crud-column-header]="columns.column('personEmail')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-smallx2" i18n="@@type.FirearmAssignment.personEmail">
                Email 
              </mat-header-cell>
            <mat-cell class="search-column-smallx2" *matCellDef="let element">
              {{element.personEmail}}
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="policeNotificationReason">
            <mat-header-cell [crud-column-header]="columns.column('policeNotificationReason')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.FirearmAssignment.policeNotificationReason">
                Police Notification Reason / Comments
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.policeNotificationReason}}
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="policeNotifiedDate">
            <mat-header-cell [crud-column-header]="columns.column('policeNotifiedDate')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.FirearmAssignment.policeNotifiedDate">
                Police Notified Date 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.policeNotifiedDate | uimDateTimeFormat}}
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="previousStartedFirearmAssignmentId">
            <mat-header-cell [crud-column-header]="columns.column('previousStartedFirearmAssignmentId')" *matHeaderCellDef 
              cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.FirearmAssignment.previousStartedFirearmAssignmentId">
                Previous Started Firearm Assignment Id 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.previousStartedFirearmAssignmentId | number:'1.0-2':'en-GB'}}
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="sortDate">
            <mat-header-cell [crud-column-header]="columns.column('sortDate')" *matHeaderCellDef 
              cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.FirearmAssignment.sortDate">
                Sort Date 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.sortDate | uimDateTimeFormat}}
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="startDate">
            <mat-header-cell [crud-column-header]="columns.column('startDate')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.FirearmAssignment.startDate">
                Start Date 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.startDate | uimDateTimeFormat}}
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="startedBy">
            <mat-header-cell [crud-column-header]="columns.column('startedBy')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.FirearmAssignment.startedBy">
                Started By 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.startedBy}}
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="updatedBy">
            <mat-header-cell [crud-column-header]="columns.column('updatedBy')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.FirearmAssignment.updatedBy">
                Updated By 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.updatedBy}}
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="updatedDate">
            <mat-header-cell [crud-column-header]="columns.column('updatedDate')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.FirearmAssignment.updatedDate">
                Updated Date 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.updatedDate | uimDateTimeFormat}}
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="username">
            <mat-header-cell [crud-column-header]="columns.column('username')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.FirearmAssignment.username">
                Username 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.username}}
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="withExpiredStartToken">
            <mat-header-cell [crud-column-header]="columns.column('withExpiredStartToken')" *matHeaderCellDef 
              cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.FirearmAssignment.withExpiredStartToken">
                With Expired Start Token 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              <mat-icon *ngIf="element.withExpiredStartToken">check_box</mat-icon><mat-icon *ngIf="!element.withExpiredStartToken">check_box_outline_blank</mat-icon>
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="withStartToken">
            <mat-header-cell [crud-column-header]="columns.column('withStartToken')" *matHeaderCellDef 
              cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.FirearmAssignment.withStartToken">
                With Start Token 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              <mat-icon *ngIf="element.withStartToken">check_box</mat-icon><mat-icon *ngIf="!element.withStartToken">check_box_outline_blank</mat-icon>
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="actions" stickyEnd>
            <mat-header-cell class="search-column-actions mat-elevation-z9" *matHeaderCellDef>
              <span i18n="@@common.actions">Actions</span>
              <app-column-picker-dialog-launcher [columns]="columns">
              </app-column-picker-dialog-launcher>
            </mat-header-cell>
            <mat-cell *matCellDef="let element" class="search-column-actions mat-elevation-z9">
              <button class="action-button" *ngIf="allowsEdit(element)" mat-raised-button color="primary"
                [routerLink]="editRoute(element)" [queryParams]="editRouteQueryParams()" i18n="@@actions.edit" id="actions.edit">Edit</button>
              <button class="action-button" [queryParams]="viewRouteQueryParams()" *ngIf="allowsView(element)" mat-raised-button color="primary"
                [routerLink]="viewRoute(element)" i18n="@@actions.view" id="actions.view">View</button>
              <button class="action-button" *ngIf="allowsDelete(element)" mat-raised-button color="accent"
                (click)="deleteWithConfirmation(element)" i18n="@@actions.delete" id="actions.delete">Delete</button>
            </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="columns.displayedColumns" class="search-table"></mat-header-row>
          <mat-row *matRowDef="let row; columns: columns.displayedColumns;" class="search-table"></mat-row>

        </mat-table>
      </div>
      <mat-paginator [length]="pageInfo.totalElements" [pageSize]="pageInfo.size" [pageSizeOptions]="pageSizes">
      </mat-paginator>

      <button class="action-button" *ngIf="allowsCreate()" mat-raised-button color="primary" [routerLink]="createRoute()"
        [queryParams]="createRouteQueryParams()" i18n="@@actions.create" id="actions.create">Create</button>
      <button class="action-button" *ngIf="allowsBack()" mat-raised-button color="accent" [routerLink]="backRoute()"
        [queryParams]="backRouteQueryParams()" i18n="@@actions.back" id="actions.back">Back</button>
    </div>
  </mat-card-content>
</mat-card>